import loadable from '@loadable/component';

export const llRequestsBO = () =>
  loadable(() => import(/* webpackChunkName: "requestsBO" */ '../../modules/backOffice/requests'), {
    resolveComponent: (
      components: typeof import('../../modules/backOffice/requests'),
      props: { component: keyof typeof import('../../modules/backOffice/requests') }
    ) => components[props.component]
  });

export const llRequestFormBO = () =>
  loadable(() => import(/* webpackChunkName: "requestFormBO" */ '../../modules/backOffice/requestForm'), {
    resolveComponent: (
      components: typeof import('../../modules/backOffice/requestForm'),
      props: { component: keyof typeof import('../../modules/backOffice/requestForm') }
    ) => components[props.component]
  });

export const llAllocationsBO = () =>
  loadable(() => import(/* webpackChunkName: "allocationsBO" */ '../../modules/backOffice/allocations'), {
    resolveComponent: (
      components: typeof import('../../modules/backOffice/allocations'),
      props: { component: keyof typeof import('../../modules/backOffice/allocations') }
    ) => components[props.component]
  });

export const llSettingsBO = () =>
  loadable(() => import(/* webpackChunkName: "settingsBO" */ '../../modules/backOffice/settings'), {
    resolveComponent: (
      components: typeof import('../../modules/backOffice/settings'),
      props: { component: keyof typeof import('../../modules/backOffice/settings') }
    ) => components[props.component]
  });

export const llProfilBO = () =>
  loadable(() => import(/* webpackChunkName: "profilBO" */ '../../modules/backOffice/profil'), {
    resolveComponent: (
      components: typeof import('../../modules/backOffice/profil'),
      props: { component: keyof typeof import('../../modules/backOffice/profil') }
    ) => components[props.component]
  });

export const llWelcomeBO = () =>
  loadable(() => import(/* webpackChunkName: "welcomeBO" */ '../../modules/backOffice/welcome'), {
    resolveComponent: (
      components: typeof import('../../modules/backOffice/welcome'),
      props: { component: keyof typeof import('../../modules/backOffice/welcome') }
    ) => components[props.component]
  });
